module.exports = __webpack_public_path__ + "img/high-3.8a17bf3d.svg";